import { useGraphneAPI, PlanningBoundarySaveView } from '@nexelem/graphne-api';
import { useCustomToast } from '@nexelem/snackbar';
import { useCustomTranslation } from '../../../../../hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { simulationMetaQueryKey } from './useSimulationMeta';

export const useSaveSimulationPlanningBoundaryMutation = () => {
  const api = useGraphneAPI();
  const queryClient = useQueryClient();
  const { tWrapper } = useCustomTranslation('components.toasts.commonMessage');
  const displayToast = useCustomToast();

  return useMutation({
    mutationFn: (planningBoundarySaveView: PlanningBoundarySaveView) =>
      api.postGraphneSimulationMetadataSavePlanningBoundary({
        planningBoundarySaveView,
      }),
    onSuccess: (_, { simulationId }) => {
      queryClient.invalidateQueries({ queryKey: simulationMetaQueryKey(simulationId.toString()) });
    },
    onError: () => {
      displayToast({
        toastType: 'error',
        message: tWrapper('error'),
      });
    },
  });
};
